module.exports = __webpack_public_path__ + "img/datatablejs.43914bfc.png";